export enum EmailType {
  PERSONAL = 'personal',
  CLUB = 'club',
  GROUP = 'group',
}

export enum EmailFolder {
  INBOX = 'inbox',
  STARRED = 'starred',
  SENT = 'sent',
  DRAFTS = 'drafts',
  ALL_MAILS = 'all_mails',
  TRASH = 'trash',

  /**
   * @exception For Message Type property value
   */
  DRAFT = 'draft',
}
